import Page from "../Page/Page";
import "../../Styles/hisstoriTvPlus.css";
import { useEffect, useState } from "react";
import { Transaction_TvExam } from "../../Connections/Transaction";
import { useNavigate } from "react-router";
import ExamModalCart from "../../Components/Alerts/ExamModalCart";
import { Link } from "react-router-dom";

const TvPlus = () => {
  const navigate = useNavigate();
  const [examList, setExamList] = useState([]);

  //get tv exams
  useEffect(() => {
    Transaction_TvExam.GetTvExams()
      .then((res) => {
        if (res[0]) {
          setExamList(res[2].data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  //exam modal status
  const [examModalStatus, setExamModalStatus] = useState(false);

  //route to Exam
  const [routeInfo, setRouteInfo] = useState({
    id: "",
    bookName: "",
    remainedExam: "",
  });

  const handleOpenModalExam = (id, bookName, remainedExam) => {
    setRouteInfo({
      id,
      bookName,
      remainedExam,
    });
    setExamModalStatus(true);
  };

  const handleRouteToExam = () => {
    navigate(`/hisstori/tv-plus/examination/${routeInfo.id}`, {
      state: { bookName: routeInfo.bookName },
    });
  };

  return (
    <>
      <Page>
        <div className="wrapper_hisstoriTvPlus">
          <div style={{ position: "relative" }}>
            <img
              className="header-bg-stars mobile-hidden"
              src={
                "https://ketabno.com/static/media/first-section-background.5913a5be96843bbb494e.svg"
              }
              alt="bg"
            />
            <img
              className="desktop-hidden header-star-mobile"
              src={"/imgs/ambassadors/1000000952.svg"}
              alt="bg"
            />
          </div>
          <section className="hisstori-knowledge-section-top">
            <img
              src="/imgs/hisstoriPlus/tv-plus-banner.svg"
              alt="knowledgeBanner"
            />
            <h1>برنامه تلویزیونی هیس‌طوری</h1>
            <p className="desc-hissotiPlus-headSection">
              برای شرکت توی این مسابقه، باید پای ثابت برنامه‌ی تلویزیونی
              هیس‌طوری باشی، این برنامه رو ببین و بیا توی آزمون شرکت کن...
            </p>
            <a
              href="https://www.aparat.com/hisstori_ir"
              target="_blank"
              rel="noreferrer"
            >
              <div className="aparat-introduction-box">
                <img
                  src="/imgs/hisstoriPlus/aparat-icon.svg"
                  alt="aparat-icon"
                />
                <div>
                  {window.outerWidth > 768 ? (
                    <>
                      <p>
                        اگـه نتونستی برنامه هیس‌طوری رو از تـلویزیون بـبینی،
                        کـلیک کن و تـوی آپـارات‌مـون ببینیش!
                      </p>
                      <p>هر روز قسمت جدید برنامه‌ رو براتون می‌ذاریم...</p>
                    </>
                  ) : (
                    <p>
                      اگـه نتونستی برنامه هیس‌طوری رو از تـلویزیون بـبینی، کـلیک
                      کن و تـوی آپـارات‌مـون ببینیش! هر روز قسمت جدید برنامه‌ رو
                      براتون می‌ذاریم...
                    </p>
                  )}
                </div>
              </div>
            </a>
          </section>
          <section className="tv-introduction-parent">
            {/* tv card  */}
            {examList.map((item) => {
              return (
                <div key={item.id} className="tv-introduction-card">
                  <div className="tv-introduction-card-side-right">
                    <img
                      className="book-image"
                      src={item.pic}
                      alt="bookImage"
                    />
                    <div>
                      <h3 className="tv-introduction-card-title">
                        {item.title}
                      </h3>
                      <p className="tv-introduction-card-description">
                        {item.book}
                      </p>
                    </div>
                  </div>
                  <div className="tv-introduction-card-side-left">
                    {/* btn 1 */}
                    <div className="tv-introduction-card-score-btn">
                      <span>
                        {item.yourScore > 0 ? item.yourScore : item.allScore}{" "}
                        {item.yourScore > 0 ? "امتیاز گرفتی" : "امتیاز"}
                        {/* {item.isSuccess ? item.yourScore : item.allScore}{" "}
                      {item.isSuccess ? "امتیاز گرفتی" : "امتیاز"} */}
                      </span>
                      <img
                        src="/imgs/bashgah/bashgah-group.svg"
                        alt="diamond-image"
                      />
                    </div>
                    {/* btn 2 */}
                    {item.isActive === false ? (
                      <div
                        style={{ backgroundColor: "#99A1E5" }}
                        className="tv-introduction-card-lock-btn"
                      >
                        <span>به زودی...</span>
                        <img
                          src="/imgs/hisstoriPlus/lock-icon.svg"
                          alt="lock-image"
                        />
                      </div>
                    ) : item.isSuccess === true ? (
                      <div
                        style={{ backgroundColor: "#483C97" }}
                        className="tv-introduction-card-lock-btn"
                      >
                        <span>موفق شدی!</span>
                        <img
                          src="/imgs/hisstoriPlus/lock-icon.svg"
                          alt="lock-image"
                        />
                      </div>
                    ) : item.remainedExam === 0 ? (
                      <div
                        style={{ backgroundColor: "#FB6161" }}
                        className="tv-introduction-card-lock-btn"
                      >
                        <span>دیگه نمی‌تونی :(</span>
                        <img
                          src="/imgs/hisstoriPlus/lock-icon.svg"
                          alt="lock-image"
                        />
                      </div>
                    ) : (
                      <div
                        onClick={() =>
                          handleOpenModalExam(
                            item.id,
                            item.book,
                            item.remainedExam
                          )
                        }
                        style={
                          item.remainedExam < item.allowAttempt
                            ? { backgroundColor: "#02948A", cursor: "pointer" }
                            : { backgroundColor: "#20724B", cursor: "pointer" }
                        }
                        className="tv-introduction-card-lock-btn"
                      >
                        <span>
                          {item.remainedExam < item.allowAttempt
                            ? "دوباره می‌تونی :)"
                            : "شروع آزمون"}
                        </span>
                        <img
                          src="/imgs/hisstoriPlus/unlock-icon.svg"
                          alt="lock-image"
                        />
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </section>
        </div>
      </Page>
      {examModalStatus && (
        <ExamModalCart
          handleRoute={() => handleRouteToExam()}
          close={() => setExamModalStatus(false)}
          image={"/imgs/hisstoriPlus/examPic.svg"}
          remainedExam={routeInfo.remainedExam}
        />
      )}
    </>
  );
};

export default TvPlus;
